export enum STATUS {
    PENDING = 1,
    RESOLVED = 2,
    REJECTED = 3,
}
